import { render, staticRenderFns } from "./awardblock.vue?vue&type=template&id=12297b9c&scoped=true&"
import script from "./awardblock.vue?vue&type=script&lang=js&"
export * from "./awardblock.vue?vue&type=script&lang=js&"
import style0 from "./awardblock.vue?vue&type=style&index=0&id=12297b9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12297b9c",
  null
  
)

export default component.exports